require('./bootstrap');
import $ from 'jquery';
import Cookies from 'js-cookie'

import helpers from './helpers'
import sliders from './sliders'
import search from './search'
import map from './map';
import reports from './reports';
window.Vue = require('vue');
import VueLazyload from 'vue-lazyload';
import vueDebounce from 'vue-debounce';
const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});




Vue.use(vueDebounce)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/images/placeholder.jpg',
  loading: '/images/placeholder.jpg',
  attempt: 1
})

var element =  document.getElementById('app');
if (typeof(element) != 'undefined' && element != null)
{
    const app = new Vue({
        el: '#app',
    });
}

$(document).ready(function(){ 
  helpers.init()
  search.init()
  reports.init()
  initCookiebox()
  if($('#singlemap').length) {
    map.initMap( $('#singlemap') );
  }

  $('.ticker__list').each(function(){
    var speed = $(this).width() / 200;
    $(this).children('.ticker__list__inner').css('animation','loop-anim '+speed+'s linear infinite');
  });
});


$( window ).on("load", function() {
  $('body').addClass('loaded')
  sliders.initSliderTimeline();
  sliders.initSliderSingle();
});

function initCookiebox() {
  if(!Cookies.get("GDPR:accepted")) {
      $('.cookies').fadeIn();
  }
  $('.cookies__btn').click(function(e) {
      e.preventDefault();
      Cookies.set('GDPR:accepted', true, { expires: 30 })
      $('.cookies').fadeOut();
  });
}